import { supabase } from "./supabase";

export interface LocalLido { id: string; codigo: string; tipo: string; descricao: string | null; bloqueado: boolean; deposito_id: string }
export interface ProdutoLido { id: string; codigo: string | null; nome: string; e_embalagem: boolean; ignorar_separacao: boolean; classe: string | null }

/** Local pelo código bipado, no depósito do usuário. */
export async function localPorCodigo(codigo: string): Promise<LocalLido | null> {
  const { data } = await supabase.rpc("wms_local_por_codigo", { p_codigo: codigo });
  return (data as LocalLido | null) ?? null;
}

/** Produto por qualquer código bipável (SKU, GTIN, alias). */
export async function produtoPorCodigo(codigo: string): Promise<ProdutoLido | null> {
  const { data } = await supabase.rpc("wms_produto_por_codigo", { p_codigo: codigo });
  return (data as ProdutoLido | null) ?? null;
}
